module.exports = __webpack_public_path__ + "img/textNo2.784ff668.jpg";